import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

/**
 * Performance Max on the YouTube home feed (desktop): landscape image ad as
 * the first tile of the video grid, with headline, description and Sponsored
 * line below. The other tiles are skeleton placeholders.
 */
@Component({
  selector: 'app-pmax-youtube-desktop-01',
  imports: [CommonModule, DesktopFrameComponent],
  templateUrl: './youtube-desktop-01.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './youtube-desktop-01.component.scss'
})
export class PmaxYoutubeDesktop01PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton guide entries in the left rail. */
  readonly sidebarItems = [0, 1, 2, 3];

  /** Skeleton video tiles filling the rest of the 3 x 2 grid. */
  readonly fillerTiles = [0, 1, 2, 3, 4];

  readonly creativeFormat: CreativeFormat = 'landscape';
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }

  get headline(): string {
    return this.data.headlines[0] || 'Your headline appears here';
  }

  get description(): string {
    return this.data.descriptions[0] || 'Your description appears here';
  }
}
